import {useQuery} from '@tanstack/react-query'
import {useEffect} from 'react'
import {QueryCacheKeys} from '../../QueryKey'
import {getUserDetail} from '../../../apis/user/getUserDetail'
import {useString} from '../../../utils/string'

const useQueryUserDetail = (id?: string, enable?: boolean) => {
    const {isNotEmpty} = useString()

    const {data, refetch, isLoading} = useQuery({
        queryKey: QueryCacheKeys.user.getUserDetail(id),
        queryFn: async () => {
            const {data} = await getUserDetail(id)
            return data
        },
        refetchOnWindowFocus: false,
        enabled: enable === false ? true : isNotEmpty(id),
    })

    useEffect(() => {
        refetch()
    }, [])

    return {data, refetch, isLoading}
}

export default useQueryUserDetail
